import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=ff553f34&scoped=true&"
import script from "./CategoryDetails.vue?vue&type=script&lang=js&"
export * from "./CategoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDetails.vue?vue&type=style&index=0&id=ff553f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff553f34",
  null
  
)

export default component.exports